import { Auth0Provider } from '@auth0/auth0-react'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { theme } from 'samba-ui'
import { ThemeProvider } from 'styled-components'

import AppWrapper from './AppWrapper'
import * as serviceWorker from './serviceWorker'
import configureStore from './store'

window.React = React
const { REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENTID } = process.env;

const Root = () => (
  <Auth0Provider
    domain={REACT_APP_AUTH0_DOMAIN}
    clientId={REACT_APP_AUTH0_CLIENTID}
    redirectUri={window.location.origin}
    audience="https://api.platform.samba.tv"
    scope="openid profile"
  >
    <Provider store={configureStore()}>
      <ThemeProvider theme={theme.v2}>
        <AppWrapper />
      </ThemeProvider>
    </Provider>
  </Auth0Provider>
);

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
